export const MANUAL_RECONCILIATION_TEXT = {
	title: 'Record actual departure/arrival',
	description: 'Specify the actual departure and arrival time of this activity for the driver',
	actualDeparture: 'Actual departure',
	actualArrival: 'Actual arrival',
	dateLabel: 'Date',
	timeLabel: 'Time',
	fromLocationLabel: 'From location',
	toLocationLabel: 'To location',
	noteLabel: 'Note',
	cancelBtn: 'Cancel',
	confirmBtn: 'Save',
	pastDateError: 'Only past dates are allowed.',
	arrivalAfterDepartureError: 'Arrival must be after departure.',
};
